import { createSignal, Show } from "solid-js";
import { getMapCacheGetImageUrl } from "../api/generated/map-cache";
import { Skeleton } from "./Skeleton";
import styles from "./MapImage.module.css";

export const MAP_CACHE_PAGE_FLAG = "MAP_CACHE_PAGE";

interface MapImageProps {
    map3: string;
    // With the hash the URL names one exact picture, so the browser keeps it for good.
    pixelHash?: string;
    alt: string;
    size?: number;
    hideWhenMissing?: boolean;
}

export default function MapImage(props: MapImageProps) {
    const [loaded, setLoaded] = createSignal(false);
    const [missing, setMissing] = createSignal(false);

    const src = () => getMapCacheGetImageUrl(encodeURIComponent(props.map3), props.pixelHash ? { v: props.pixelHash } : undefined);

    return (
        <Show when={!(missing() && props.hideWhenMissing)}>
            <div class={styles.frame} style={props.size ? { width: `${props.size}px` } : undefined}>
                <Show when={!missing()} fallback={<div class={styles.missing}><i class="fa-solid fa-map" aria-hidden="true" /></div>}>
                    <img
                        class={styles.image}
                        src={src()}
                        alt={props.alt}
                        loading="lazy"
                        onLoad={() => setLoaded(true)}
                        onError={() => setMissing(true)}
                    />
                    <Show when={!loaded()}>
                        <Skeleton variant="rect" class={styles.loading} height="100%" radius={0} />
                    </Show>
                </Show>
            </div>
        </Show>
    );
}
